jQuery(document).ready(function($) {

    $('.footer-nav .hdln-4').on('click', function() {
        // Check if the screen width is less than or equal to 575px
        if ($(window).width() <= 768) {
            const $menuContainer = $(this).next('ul');

            // If the current menu container is not visible, we're going to show it
            if(!$menuContainer.is(':visible')) {
                // Slide up all 'ul' elements
                $('.footer-nav ul').slideUp();

                // Remove the 'active' class from all h4 elements
                $('.footer-nav .hdln-4').removeClass('active');

                // Slide down the current 'ul' and add 'active' class to the corresponding h4
                $menuContainer.slideDown();
                $(this).addClass('active');
            } else {
                // If the menu was already visible, simply hide it and remove the 'active' class
                $menuContainer.slideUp();
                $(this).removeClass('active');
            }
        }
    });

});
